import { AxiosResponse } from 'axios';

/**
 * Shared types & constants for the BfS (SozialBank) Double-Opt-In landing pages
 * (EBS-64). The applicant reaches these pages via links in the marketing-consent
 * email; the CleverReach token is carried in the URL query string.
 */

/** Query-string key carrying the DOI token from the email link. */
export const BFS_DOI_TOKEN_QUERY_KEY = 'token';

/** Visual state rendered by {@link BfsDoiResultPage}. */
export type BfsDoiResultStatus = 'loading' | 'success' | 'error';

export type BfsDoiMutationVariables = {
  token: string;
};

export type BfsDoiMutationResponse = AxiosResponse<null>;
